import { render } from "./QuadroKanban.vue?vue&type=template&id=ae0f2ce0"
import script from "./QuadroKanban.vue?vue&type=script&lang=js"
export * from "./QuadroKanban.vue?vue&type=script&lang=js"

import "@/assets/styles.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__